<script>
import 'leaflet.pm';
import 'leaflet.pm/dist/leaflet.pm.css';

export default {
	name: 'LeafletPm',
	inheritAttrs: false,
	inject: [ 'leaflet', 'state' ],
	props: {
		location: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			rendered: false,
			leafletItem: null,
			layers: []
		};
	},
	watch: {
		location: {
			handler() {
				this.rerender();
			}
		},

	},
	mounted() {
		this.state.map.on('pm:create', e => {
			let { layer } = e;
			this.$emit('editGeoJson', layer.toGeoJSON() );
			this.layers.push(layer);
			layer.on('pm:edit', () => {
				this.$emit('editGeoJson', layer.toGeoJSON());
			});
		});
	},
	beforeDestroy() {
		if (this.state.map) {
			if (this.leafletItem) {
				this.leafletItem.remove();
			}
			for (let layer of this.layers) {
				layer && layer.remove();
			}
			this.layers = [];
			this.rendered = false;
			this.state.map.off('pm:create');
			this.state.map.off('pm:edit');
		}
	},
	methods: {
		drawArea() {
			if (this.state && this.state.map) {
				this.state.map.pm.enableDraw('Polygon', { tooltips: false });
			}
		},
		editArea() {
			// enable edit mode
			this.state.map.pm.toggleGlobalEditMode();
		},
		removeArea() {
			this.leafletItem && this.leafletItem.remove();
			this.leafletItem = null;
			for (let layer of this.layers) {
				layer && layer.remove();
			}
			this.layers = [];
			this.$emit('editGeoJson', null );
		},
		rerender() {
			if (this.leafletItem) {
				this.leafletItem.remove();
				this.leafletItem.off('pm:edit');
				this.leafletItem = null;
			}
			if (this.location.area) {
				this.leafletItem = this.leaflet.geoJSON(this.location.area);
				this.leafletItem.on('pm:edit', () => {
					this.$emit('editGeoJson', this.leafletItem.toGeoJSON());
				});
			}
			this.rendered = false;
		}
	},
	render() {
		if (this.state.map && this.leafletItem && !this.rendered) {
			if (this.leafletItem && this.state.map.hasLayer(this.leafletItem)) {
				  this.leafletItem.remove();
			}
			this.leafletItem.addTo(this.state.map);
			this.state.map.fitBounds(this.leafletItem.getBounds());
			this.rendered = true;
		}
		return null;
	}
};
</script>
